export enum WillCountry {
    australia = 'Australia',
    britishVirginIslands = 'BritishVirginIslands',
    canada = 'Canada',
    caymanIslands = 'CaymanIslands',
    france = 'France',
    germany = 'Germany',
    gibraltar = 'Gibraltar',
    guernsey = 'Guernsey',
    hongKong = 'HongKong',
    india = 'India',
    ireland = 'Ireland',
    isleOfMan = 'IsleOfMan',
    israel = 'Israel',
    italy = 'Italy',
    japan = 'Japan',
    jersey = 'Jersey',
    luxembourg = 'Luxembourg',
    malaysia = 'Malaysia',
    // mainlandChina = "Mainland China",
    newZealand = 'NewZealand',
    philippines = 'Philippines',
    singapore = 'Singapore',
    southAfrica = 'SouthAfrica',
    // sweden = 'Sweden',
    switzerland = 'Switzerland',
    taiwan = 'Taiwan',
    thailand = 'Thailand',
    unitedKingdom = 'UnitedKingdom',
    unitedStates = 'UnitedStatesOfAmerica',
    vietnam = 'Vietnam',
}

export const PLATFORM_COUNTRIES: WillCountry[] = [
    WillCountry.australia,
    WillCountry.hongKong,
    WillCountry.singapore,
    WillCountry.malaysia,
    WillCountry.unitedKingdom,
    WillCountry.unitedStates,
];

export const OFF_PLATFORM_COUNTRIES: WillCountry[] = Object.values(WillCountry).filter(
    country => country !== WillCountry.thailand && country !== WillCountry.vietnam && !PLATFORM_COUNTRIES.includes(country)
);
